module.exports = __webpack_public_path__ + "static/media/image_9.ad70fb5d.png";